import React, { FC, useContext } from 'react';
import { AddEntityWatcherButton } from '../../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import styles from './law_firm_follow.module.scss';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';
import { LawFirmContext } from '../../LawFirmContext';

export const LawFirmFollow: FC = () => {
  const source = 'law_firm_page';
  const { openRestrictedModal } = useRestrictedModal();
  const {
    lawFirmInfos: { name, lawOfficeIdGroup },
  } = useContext(LawFirmContext);

  return (
    <div className={styles.container} id="add-watcher-law-firm">
      <AddEntityWatcherButton
        query={name}
        entityIdParams={{ oid: lawOfficeIdGroup }}
        uniqueId={lawOfficeIdGroup}
        restrict={() =>
          openRestrictedModal({ source: 'want_to_follow_law_firm' })
        }
        source={source}
      />
    </div>
  );
};
